import React, { Fragment, useEffect } from 'react' 
import {  Link, useNavigate} from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { LinkContainer } from 'react-router-bootstrap'
import {Navbar, Nav, Container, NavDropdown, Img, Button, DropdownButton, Dropdown, Card } from 'react-bootstrap'

const Header = () => {

    const dispatch = useDispatch()
    const history = useNavigate();


    useEffect(() => {


    }, [])

    const navigateToHome = () => {
        history.push('/')
    }


    return (
        <header className="header" style={{
            border: 'none',
            marginBottom: '0px',
            borderLeft: 'none',
            borderRight: 'none',
            background: 'linear-gradient(90deg, #0C0854 0%, #6b0752 100%)',
            boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
            padding: 0,
        }}>
            <Navbar expand="lg" collapseOnSelect style={{ padding: '0.5rem 0', background: 'transparent', borderColor: 'transparent' }}>
                <Container>
                    <LinkContainer to='/'>
                        <>
                            <Link to='/'>
                                <Button style={{
                                    margin: '1px',
                                    paddingTop: '7px',
                                    paddingBottom: '7px',
                                    paddingLeft: '18px',
                                    paddingRight: '18px',
                                    borderRadius: '22px',
                                    backgroundColor: 'white',
                                    color: '#0C0854',
                                    fontWeight: 700,
                                    fontSize: '1.1rem',
                                    border: 'none',
                                    boxShadow: '0 1px 6px rgba(0,0,0,0.04)',
                                    letterSpacing: '0.03em',
                                }}>
                                    Pixagan.AI
                                </Button>
                            </Link>
                        </>
                    </LinkContainer>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="ml-auto">
                            {/* <LinkContainer to='/'>
                                <Nav.Link className='navbarlink'>
                                    <Button style={{
                                        margin: '1px',
                                        paddingTop: '7px',
                                        paddingBottom: '7px',
                                        borderRadius: '20px',
                                        backgroundColor: 'rgba(255,255,255,0.92)',
                                        color: '#0C0854',
                                        border: 'none',
                                        fontWeight: 500,
                                        fontSize: '1rem',
                                        boxShadow: '0 1px 6px rgba(0,0,0,0.04)'
                                    }}><i className="fa fa-home"></i></Button>
                                </Nav.Link>
                            </LinkContainer> */}
                            {/* <LinkContainer to='/snippets'>
                                <Nav.Link className='navbarlink'>
                                    <Button style={{
                                        margin: '1px',
                                        paddingTop: '7px',
                                        paddingBottom: '7px',
                                        borderRadius: '20px',
                                        backgroundColor: 'rgba(255,255,255,0.92)',
                                        color: '#0C0854',
                                        border: 'none',
                                        fontWeight: 500,
                                        fontSize: '1rem',
                                        boxShadow: '0 1px 6px rgba(0,0,0,0.04)'
                                    }}>Snippets</Button>
                                </Nav.Link>
                            </LinkContainer> */}
                             <LinkContainer to='/learn'>
                                <Nav.Link className='navbarlink'>
                                    <Button style={{
                                        margin: '1px',
                                        paddingTop: '7px',
                                        paddingBottom: '7px',
                                        borderRadius: '20px',
                                        backgroundColor: 'rgba(255,255,255,0.92)',
                                        color: '#0C0854',
                                        border: 'none',
                                        fontWeight: 500,
                                        fontSize: '1rem',
                                        boxShadow: '0 1px 6px rgba(0,0,0,0.04)'
                                    }}>Learn</Button>
                                </Nav.Link>
                            </LinkContainer>
                            <LinkContainer to='/doqlets'>
                                <Nav.Link className='navbarlink'>
                                    <Button style={{
                                        margin: '1px',
                                        paddingTop: '7px',
                                        paddingBottom: '7px',
                                        borderRadius: '20px',
                                        backgroundColor: 'rgba(255,255,255,0.92)',
                                        color: '#0C0854',
                                        border: 'none',
                                        fontWeight: 500,
                                        fontSize: '1rem',
                                        boxShadow: '0 1px 6px rgba(0,0,0,0.04)'
                                    }}>Doqlets</Button>
                                </Nav.Link>
                            </LinkContainer>
                            {/* <LinkContainer to='/deeproots'>
                                <Nav.Link className='navbarlink'>
                                    <Button style={{
                                        margin: '1px',
                                        paddingTop: '7px',
                                        paddingBottom: '7px',
                                        borderRadius: '20px',
                                        backgroundColor: 'rgba(255,255,255,0.92)',
                                        color: '#0C0854',
                                        border: 'none',
                                        fontWeight: 500,
                                        fontSize: '1rem',
                                        boxShadow: '0 1px 6px rgba(0,0,0,0.04)'
                                    }}>Deeproots</Button>
                                </Nav.Link>
                            </LinkContainer> */}
                            {/* <LinkContainer to='/laeyerz'>
                                <Nav.Link className='navbarlink'>
                                    <Button style={{
                                        margin: '1px',
                                        paddingTop: '7px',
                                        paddingBottom: '7px',
                                        borderRadius: '20px',
                                        backgroundColor: 'rgba(255,255,255,0.92)',
                                        color: '#0C0854',
                                        border: 'none',
                                        fontWeight: 500,
                                        fontSize: '1rem',
                                        boxShadow: '0 1px 6px rgba(0,0,0,0.04)'
                                    }}>Laeyerz</Button>
                                </Nav.Link>
                            </LinkContainer> */}
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </header>
    )
}

export default Header